// import { debouncer, documentReady } from "../Utility/utils";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';


const initializeBlock = function( $block ){
  // First, Determine which block we're in, and set the args accordingly.
  let slider;
  let args;
  let splide;
  let arrowPath = 'M40,18.28H5.77L14.42,9.62c.67-.67,.67-1.77,0-2.44-.67-.67-1.77-.67-2.44,0L.59,18.57c-.38,.38-.59,.89-.59,1.43s.21,1.05,.59,1.43l11.39,11.39c.34,.34,.78,.51,1.22,.51s.88-.17,1.22-.51c.67-.67,.67-1.76,0-2.44L5.76,21.72H40v-3.45Z';

  // For backend, ensure we're targeting the actual block.
  if(!!$block[0]){
    $block = $block[0];
  }

  // Default Slider Block
  if(!!$block.querySelector('.slider_block__slider')){
    slider = $block.querySelector('.slider_block__slider');

    splide = new Splide( slider, {
      type   : 'loop',
      pagination : false,
      flickPower: 250,
      flickMaxPages: 1,
      autoplay: true,
      interval: 6000,
      arrowPath: arrowPath,
      speed: 750,
      breakpoints: {
        767: {
          pagination: true
        },
      }
    } );
  }

  // Card Grid Slider
  if($block.classList.contains('card_grid') && $block.classList.contains('slider_mb')){
    slider = $block;
    let destroy = false;
    let destroy1160 = false;
    let arrows1160 = true;

    if(!$block.classList.contains('slider_dt')){
      destroy = true;
      destroy1160 = true;
    }
    if($block.querySelectorAll('.splide__slide').length <= 3){
      destroy1160 = true;
      arrows1160 = false;
    }

    splide = new Splide( slider, {
      type   : 'loop',
      pagination : true,
      arrows: false,
      flickPower: 250,
      flickMaxPages: 1,
      autoplay: true,
      interval: 6000,
      speed: 750,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          // type: 'slide',
          perPage: 2,
          destroy: destroy,
        },
        1160: {
          perPage: 3,
          destroy: destroy1160,
          arrows: arrows1160,
          arrowPath: arrowPath,
        }
      }
    } );

    // add class to parent container to avoid horizontal overflow scrolling
    const parent = slider.closest('.page-section');
    if(!!parent){
      parent.classList.add('slider-overflow-wrapper');
    }
  }

  // Post Filters
  if($block.classList.contains('post_filters')){
    slider = $block.querySelector('.splide');

    splide = new Splide( slider, {
      type   : 'slide',
      drag : 'free',
      pagination : false,
      arrows: false,
      autoplay: false,
      mediaQuery: 'min',
      autoWidth: true,
    } );

    // Check if each slide is on screen, and if so, add a class that disables the transform on the splide__list
    disable_drag(slider);

    let dragTimeout;
    window.addEventListener('resize', () => {
      cancelTimeout(dragTimeout);
      dragTimeout = setTimeout(() => {
        disable_drag(slider);
      }, 100);
    });
  }

  // Handle active slide class
  if(splide){
    splide.on('move', (newIndex, prevIndex) => {
      td_splide_active_class(newIndex, prevIndex, slider)
    })

    splide.on('mounted', () => {
      td_splide_active_class(0, null, slider)
    })

    // mount slider
    splide.mount();

    // remove focus on arrows on click
    const arrows = slider.querySelectorAll('button');
    if(!!arrows){
      arrows.forEach((arrow) => {
        arrow.addEventListener('click', (e)=>{
          if(e.pointerType){
            arrow.blur();
          }
        });
      });
    }
  }
}

// Check if all slides are on screen to disable drag functionality
function disable_drag(slider){
  const lastSlide = slider.querySelector('.splide__slide:last-child');
  if(!!lastSlide){
    const slideRightPos = lastSlide.offsetLeft + lastSlide.offsetWidth;
    const sliderWidth = slider.offsetWidth;
    if(slideRightPos > sliderWidth && slider.classList.contains('disable_drag')) {
      slider.classList.remove('disable_drag');
    }
    else if(slideRightPos <= sliderWidth && !slider.classList.contains('disable_drag')){
      slider.classList.add('disable_drag');
    }
  }
}

// By default, there's a delay before splide changes it's active slide class. We'll add our own
function td_splide_active_class(newIndex, prevIndex, slider){
  if(newIndex !== prevIndex){
    const activeClass = 'td-is-active';
    const slides = slider.querySelectorAll('.splide__slide:not(.splide__slide--clone)');
    const slideCount = slides.length;
    const activeSlide = slides[newIndex];
    const activeSlideNumber = newIndex + 1;
    const activeClone = slider.querySelector('.splide__slide.splide__slide--clone[aria-label="' + activeSlideNumber + ' of ' + slideCount + '"]');
    activeSlide.classList.add(activeClass);
    if(!!activeClone){
      activeClone.classList.add(activeClass);
    }

    if(prevIndex !== null){
      const prevSlideNumber = prevIndex + 1;
      const prevSlide = slides[prevIndex];
      const prevClone = slider.querySelector('.splide__slide.splide__slide--clone[aria-label="' + prevSlideNumber + ' of ' + slideCount + '"]');
      prevSlide.classList.remove(activeClass);
      if(!!prevClone){
        prevClone.classList.remove(activeClass);
      }
    }
  }
}

// Initialize the slider on the front end
window.addEventListener('load', function(){
  var sliders = document.querySelectorAll('.slider_block, .card_grid.slider_mb, .post_filters');
  Array.prototype.forEach.call(sliders, function(el, i){
    initializeBlock(el);
  });
});


// Initialize dynamic block preview (editor).
if( window.acf ) {
  window.acf.addAction( 'render_block_preview/type=slider', initializeBlock );
  window.acf.addAction( 'render_block_preview/type=card-grid', initializeBlock );
}
